module.exports = __webpack_public_path__ + "img/TSY_04_01.82cf1c4c.png";